import { render, staticRenderFns } from "./SingleSelectDropdown.vue?vue&type=template&id=18821eb8&"
import script from "./SingleSelectDropdown.vue?vue&type=script&lang=js&"
export * from "./SingleSelectDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18821eb8')) {
      api.createRecord('18821eb8', component.options)
    } else {
      api.reload('18821eb8', component.options)
    }
    module.hot.accept("./SingleSelectDropdown.vue?vue&type=template&id=18821eb8&", function () {
      api.rerender('18821eb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/components/SingleSelectDropdown.vue"
export default component.exports